import Model from "./Model";
import { ClassTransformOptions, plainToClass, Type } from "class-transformer";
import Practitioner from "./Practitioner";
import ActCategory from "./ActCategory";

class Act extends Model {
    id: number;
    practitioner_id: number;
    establishment_id: number;
    name: string;
    insurance_alias: string;
    code: string;
    fees: number;
    fees_adults: number;
    fees_kids: number;
    coefficient: string;
    refundable: boolean;

    /*
    |--------------------------------------------------------------------------
    | Reflection
    |--------------------------------------------------------------------------
    */

    /**
     * Gets class name
     * survives minification/uglification
     *
     * @return {string}
     */
    getClassName(): string {
        return 'Act';
    }

    /*
    |--------------------------------------------------------------------------
    | Relationships
    |--------------------------------------------------------------------------
    */

    @Type(() => Practitioner)
    practitioner: Practitioner;

    @Type(() => ActCategory)
    category: ActCategory;

    /*
    |--------------------------------------------------------------------------
    | Methods
    |--------------------------------------------------------------------------
    */

    /**
     *  Get act category name
     *
     * @return {string|null}
     */
    categoryName() {
        return this.category?.name;
    }

    /**
     * Converts plain (literal) object to class (constructor) object. Also works with arrays.
     */
    static new(plain: [], options?: ClassTransformOptions): Act[];
    static new(plain: {}, options?: ClassTransformOptions): Act;
    static new(plain: {} | [], options?: ClassTransformOptions): Act | Act[] {
        return plainToClass(Act, plain as any, options);
    }

}

export default Act;